import * as React from 'react';

export const useMousePosition = (slideRef, showPointer) => {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });

    React.useEffect(() => {
        const boundaries = slideRef.current?.getBoundingClientRect();

        const setFromEvent = evt => {
            const { top, left, height, width } = boundaries;
            const { clientX: x, clientY: y } = evt;

            const xAdjust = width - 30;
            const yAdjust = height - 50;

            const rightBoundary = left + xAdjust;
            const bottomBoundary = top + yAdjust;

            const withinXBoundaries = x >= left && x <= rightBoundary;
            const withinYBoundaries = y >= top && y <= bottomBoundary;

            const offsetX = x - left;
            const offsetY = y - top + 30;
            // Add 30px offset to the pointer so it's not directly on top of mouse

            const adjustedY = offsetY >= yAdjust ? yAdjust : offsetY;

            if (withinXBoundaries && withinYBoundaries) {
                setPosition({ x: offsetX, y: adjustedY });
            }
        };

        if (showPointer && slideRef.current) {
            slideRef.current.addEventListener('mousemove', setFromEvent);
        }
        
        return () => {
            if (showPointer && slideRef && slideRef.current) {
                slideRef.current.removeEventListener('mousemove', setFromEvent);
            }
        };
    }, [showPointer]);

    return position;
};